import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from '../../AuthContext';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import {api} from '../Login/axiosConfig';
import { Container, Typography, Button, Card, Box, CardContent, Grid, Checkbox, FormControlLabel, IconButton, TextField, Divider, Stack } from '@mui/material';
import { motion } from "framer-motion";
import { AccessTime, Language, AttachMoney, Person, Event } from '@mui/icons-material';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import AddressByPincode from '../PostalAddress/AddressByPincode';
import Header1 from '../Header/Header1';
import Platform from '../Platform/Platform';
import CircularProgress from '@mui/material/CircularProgress';

const NewSubscriptionPayments = ({ onLogout }) => {

    const { state } = useLocation();

     const {
    subscription_id,
    plan,
    final_price,
    original_price,
    credit_applied,
  } = state;


    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);

    const { userId } = useAuth();
    const [csrfToken, setCsrfToken] = useState('');
    const [courses, setCourses] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const price = final_price;
    const [paymentMethod, setPaymentMethod] = useState("razorpay");
// const [upiId, setUpiId] = useState("");

    const navigate = useNavigate();

    const params = useParams();
    const type = params.type;
    const post_id = params.id;

//     const PLAN_LABELS = {
//   MONTHLY: "Monthly Subscription",
//   QUARTERLY: "Quarterly Subscription",
//   ANNUAL: "Annual Subscription",
// };

// const PLAN_DURATIONS = {
//   MONTHLY: "30 Days",
//   QUARTERLY: "3 Months",
//   ANNUAL: "1 Year",
// };

const PLAN_LABELS = {
  // Platform
  MONTHLY: "Monthly Subscription",
  QUARTERLY: "Quarterly Subscription",
  ANNUAL: "Annual Subscription",

  // AI Plans
  AI_MONTHLY: "AI Monthly Membership",
  AI_6_MONTHS: "AI 6 Months Membership",
  AI_ANNUAL: "AI Annual Membership",
};
const PLAN_DURATIONS = {
  // Platform
  MONTHLY: "30 Days",
  QUARTERLY: "3 Months",
  ANNUAL: "1 Year",

  // AI Plans
  AI_MONTHLY: "1 Month",
  AI_6_MONTHS: "6 Months",
  AI_ANNUAL: "1 Year",
};

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB");

const formatTime = (date) =>
  new Date(date).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });


    const [bookingCreated, setBookingCreated] = useState(false);
    const hasCalledApi = useRef(false); // useRef to track whether API has been called

    const [couponCode, setCouponCode] = useState('');
    const [isCouponValid, setIsCouponValid] = useState(false); // Optional: validation flag

    // const [totalDiscountedPrice,setTotalDiscountedPrice] = useState(0)

    const [couponDiscountPercent, setCouponDiscountPercent] = useState(0);
    const [couponApplied, setCouponApplied] = useState(false);
    const [totalDiscountedPrice, setTotalDiscountedPrice] = useState(0);

    const [userData, setUserData] = useState({
        "name": "",
        "about": "",
        "contact": "",
        "designation": "",
        "created_at": "",
        "dob": "",
        "email": "",
        "gender": "",
        "id": "",
        "image": "",
        "languages": "",
        "password": "",
        "rating": "",
        "role": "",
        "status": "",
        "surname": "",
        "address": "",
        "city": "",
        "state": "",
        "country": "",
        "pincode": "",
        "updated_at": "",
        "facebook": "",
        "instagram": "",
        "x": "",
        "linkedin": "",
        "youtube": "",
        "currentLevel": "Advanced",
        "totalTimeLearning": "150 hrs",
        "totalTimeTeaching": "50 hrs",
        "totalSessions": "25",
        "ratings": "4.8/5",
    });


    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(false);
    const [loadingSeconds, setLoadingSeconds] = useState(0);

    useEffect(() => {
        let timer;

        if (loading) {
            setLoadingSeconds(0); // reset timer
            timer = setInterval(() => {
                setLoadingSeconds(prev => prev + 1);
            }, 1000);
        } else {
            clearInterval(timer);
            setLoadingSeconds(0); // optional reset after done
        }

        return () => clearInterval(timer); // cleanup on unmount or loading = false
    }, [loading]);





    useEffect(() => {
        if (!userId) {
            return;
        }

        const fetchUserData = async () => {
            setLoading(true); // Start loading

            try {
                const response = await api.get(`${API_URL}/get_user_data/`, {
                    params: { user_id: userId },
                });
                setUserData(response.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false); // Stop loading (runs in both success and error cases)
            }
        };

        fetchUserData();
    }, [userId]);


    const CreateTransactions = async (transactionId, status, paymentReason, id) => {
        setLoading(true); // Start loading

        const postData = {
            user_id: userId,
            // post_id: post_id,
            order_id: id,
            subscription_id: subscription_id,
    plan: plan,
    final_price : final_price,
    original_price: original_price,
    credit_applied : credit_applied,
            transaction_id: transactionId,
            amount: couponApplied ? parseFloat(totalDiscountedPrice) : parseFloat(totalPrice),
            status: status,
            payment_reason: paymentReason,
            coupon_code: couponCode
        };

        try {
            await api.post(`${API_URL}/create_transactions_new_subscriptions/`, postData);
            // handle success if needed
        } catch (error) {
            console.error('Error saving transaction:', error);
        } finally {
            setLoading(false); // Stop loading regardless of outcome
        }
    };





    useEffect(() => {
        const fetchCsrfToken = async () => {
            setLoading(true); // Start loading
            try {
                const response = await api.get(`${API_URL}/get-csrf-token/`, { withCredentials: true });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            } finally {
                setLoading(false); // End loading
            }
        };
        fetchCsrfToken();
    }, []);



    const GST_RATE = 0.18;
    const gateway_rate = 0.02;

    const gstAmount = parseFloat((price * GST_RATE).toFixed(2));
    // const gatewayAmount = parseFloat((courses.price * gateway_rate).toFixed(2));
    const baseTotalPrice = parseFloat((parseFloat(price) + gstAmount).toFixed(2));

    const totalPrice = couponApplied
        ? parseFloat(totalDiscountedPrice)
        : baseTotalPrice;


    const gatewayCharges = parseFloat((totalPrice * gateway_rate).toFixed(2));

    // 4. Final total price after adding gateway charges
    const totalPay = parseFloat((totalPrice + gatewayCharges).toFixed(2));

//  const handlePhonePePayment = async () => {
//   try {
//     setLoading(true);

//     const res = await api.post(`${API_URL}/phonepe-payment/`, {
//       amount: totalPay,
//     });

//     const redirectUrl = res.data?.redirectUrl;
//     const orderId = res.data?.orderId;

//     localStorage.setItem("phonepe_order_id", orderId);
// //      localStorage.setItem("phonepe_payment_data", JSON.stringify({
// //   user_id: userId,
// //   subscription_id: subscription_id,
// //   amount: totalPay,
// //   plan: plan,
// //   final_price: final_price,
// //   original_price: original_price,
// //   credit_applied: credit_applied
// // }));

//     if (redirectUrl) {
//       window.location.replace(redirectUrl);
//     } else {
//       console.error("Invalid response:", res.data);
//       alert("Payment initialization failed");
//       setLoading(false);
//     }

//   } catch (err) {
//     console.error(err);
//     alert("PhonePe payment failed");
//     setLoading(false);
//   }
// };
const handlePhonePePayment = async () => {
  try {
    setLoading(true);

    const res = await api.post(`${API_URL}/phonepe-subscription-payment/`, {
      amount: totalPay,
      plan: plan,
    });

    const redirectUrl = res.data?.redirectUrl;
    const orderId = res.data?.orderId;
    const subscriptionId = res.data?.subscription_id;

    console.log("PHONEPE SUBSCRIPTION RESPONSE:", res.data);

    if (!subscriptionId) {
      alert("Subscription creation failed");
      setLoading(false);
      return;
    }

    localStorage.setItem("phonepe_order_id", orderId);

    localStorage.setItem(
      "phonepe_payment_data",
      JSON.stringify({
        user_id: userId,
        subscription_id: subscriptionId,
        amount: totalPay,
        plan: plan,
        final_price: totalPay,
        original_price: totalPay,
        credit_applied: credit_applied || 0,
        payment_reason: "Subscription Purchase",
      })
    );

    if (redirectUrl) {
      window.location.replace(redirectUrl);
    } else {
      alert("Payment initialization failed");
      setLoading(false);
    }

  } catch (err) {
    console.error(err);
    alert("PhonePe payment failed");
    setLoading(false);
  }
};

    const handlePayment = async () => {
        setLoading(true);

        let missingFields = [];

        if (!csrfToken) missingFields.push('CSRF Token');
        if (!price) missingFields.push('Price');
        if (!userData.city) missingFields.push('City');
        if (!userData.state) missingFields.push('State');
        if (!userData.country) missingFields.push('Country');
        if (!userData.pincode) missingFields.push('Pincode');

        if (missingFields.length > 0) {
            alert('Please fill the required details for making the payment: ' + missingFields.join(', ') + '.');
            return;
        }

        try {
            const response = await api.post(
                `${API_URL}/create-subscription/`,
                {
                    amount: Math.round(totalPay * 100), // Amount in paise as an integer
                },

                {
                    headers: {
                        'X-CSRFToken': csrfToken,
                    },
                    withCredentials: true,
                }
            );

            const { id } = response.data;

            if (!id) {
                console.error('No order ID received.');
                return;
            }

            const options = {
                key:'rzp_live_7e0OC9qGVaGXLr',
                // key: 'rzp_test_iLMcsP06UTqoWj', // Razorpay key ID
                amount: Math.round(totalPay * 100), // Amount in paise
                currency: 'INR',
                name: 'Anthrasync',
                description: 'Transaction',
                order_id: id,
                handler: function (response) {
                    CreateTransactions(response.razorpay_payment_id, 'success', 'Payment successful', id);
                    alert(`Payment successful: ${response.razorpay_payment_id}`);
                    navigate(`/subscription-page`, { state: { paymentStatus: 'success', paymentId: response.razorpay_payment_id } });
                },
                modal: {
                    ondismiss: function () {
                        CreateTransactions(null, 'failed', 'Payment was cancelled', id);
                        alert('Payment was cancelled');
                        navigate(`/subscription-page`, { state: { paymentStatus: 'cancelled' } });
                    },
                },
                prefill: {
                    name: userData.name,
                    email: userData.email,
                    contact: userData.contact,
                },
                theme: {
                    color: '#F37254',
                },
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error('Payment error:', error.response || error.message);
        } finally {
            setLoading(false); // End loading
        }
    };

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // const formatTime = (timeString) => {
    //     const time = new Date(`1970-01-01T${timeString}Z`);  // Use a fixed date (1970) to parse time
    //     return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });  // Format to 12-hour AM/PM
    // };

    const formatDuration = (durationInMinutes) => {
        const hours = Math.floor(durationInMinutes / 60);
        const minutes = durationInMinutes % 60;

        // If duration is less than an hour, only show minutes
        if (hours > 0) {
            return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
        }

        return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    };

    const handleApplyCoupon = async () => {

        if (!couponCode.trim()) {
            alert('Please enter a coupon code.');
            return;
        }

        setLoading(true);

        try {
            const response = await api.post(`${API_URL}/api/validate-coupon/`, {
                coupon_code: couponCode,
            });

            if (response.status === 200) {
                const { discount } = response.data;
                setCouponDiscountPercent(discount);
                setIsCouponValid(true);
                setCouponApplied(true);

                const discountAmount = baseTotalPrice * (discount / 100);
                const discounted = baseTotalPrice - discountAmount;

                setTotalDiscountedPrice(discounted.toFixed(2));
                // alert(`Coupon applied! You get a ${discount}% discount.`);
            }
        } catch (error) {
            setIsCouponValid(false);
            setCouponApplied(false);
            setCouponDiscountPercent(0);
            setTotalDiscountedPrice(0);
            alert('Invalid or expired coupon.');
        } finally {
            setLoading(false); // End loading
        }
    };

    const handleRemoveCoupon = () => {
        setCouponCode('');
        setCouponApplied(false);
        setCouponDiscountPercent(0);
        setTotalDiscountedPrice(totalPrice); // Reset to original price
    };



    //  const GST_RATE = 0.18;
    // const gstAmount = parseFloat((courses.price * GST_RATE).toFixed(2));

    // const gateway_rate = 0.02;
    // const gatewayAmount = parseFloat((courses.price * gateway_rate).toFixed(2));

    // // Ensure all parts are numbers before applying toFixed
    // const totalPrice = parseFloat((parseFloat(courses.price) + gstAmount + gatewayAmount).toFixed(2));


    return (
        <div>
            <Box
                sx={{
                    position: 'fixed', // or 'relative' / 'sticky' based on your layout
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1300, // higher than MUI drawers (default is 1200)
                }}
            >
                <Header1 />
            </Box>


            {/* <Box>
                                                <Platform userId={userId} onLogout={onLogout}/>
                                              </Box> */}


            <Container maxWidth="lg" sx={{ py: 6 }}>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom
                    sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 8, mb: 5, mt: 10 }}
                >
                    Booking & Order Details
                </Typography>

                <Grid container spacing={4}>
                    {/* Left Column: Booking Info + Address */}
                    <Grid item xs={12} md={6}>
                        <Stack spacing={4}>
                            {/* Booking Info */}
                            <motion.div whileHover={{ scale: 1.02 }}>
                                <Card sx={{ bgcolor: "#0d1117", p: 3, borderRadius: 3 }}>
  <Typography
    variant="h6"
    sx={{ color: "#ffffff", mb: 2, letterSpacing: 2 }}
  >
    Order Info
  </Typography>

  <Divider sx={{ bgcolor: "#30363d", mb: 2 }} />

  {[
    ["Subscription Plan", PLAN_LABELS[plan]],
    ["Start Date", formatDate(new Date())],
    ["Start Time", formatTime(new Date())],
    ["Active Period", PLAN_DURATIONS[plan]],
  ].map(([label, value]) => (
    <Typography
      key={label}
      variant="body2"
      sx={{ color: "#c9d1d9", mb: 1 }}
    >
      <strong>{label}:</strong> {value}
    </Typography>
  ))}
</Card>

                            </motion.div>

                            {/* Address */}
                            <motion.div whileHover={{ scale: 1.02 }}>
                                <Card sx={{ bgcolor: "#0d1117", p: 3, borderRadius: 3 }}>
                                    <Typography variant="h6" sx={{ color: "#ffffff", mb: 2, letterSpacing: 2 }}>
                                        Billing Address  Details
                                    </Typography>
                                    <Divider sx={{ bgcolor: "#30363d", mb: 2 }} />
                                    <AddressByPincode onUpdate={() => window.location.reload()} />
                                </Card>
                            </motion.div>
                        </Stack>
                    </Grid>

                    {/* Right Column: Billing + Pricing + Confirmation */}
                    <Grid item xs={12} md={6}>
                        <Stack spacing={4}>
                            {/* Billing Info */}
                            <motion.div whileHover={{ scale: 1.02 }}>
                                <Card sx={{ bgcolor: "#0d1117", p: 3, borderRadius: 3 }}>
                                    <Typography variant="h6" sx={{ color: "#ffffff", mb: 2, letterSpacing: 2 }}>
                                        Personal Info
                                    </Typography>
                                    <Divider sx={{ bgcolor: "#30363d", mb: 2 }} />
                                    {[
                                        ["Name", `${userData.name} ${userData.surname}`],
                                        ["Email", userData.email],
                                        ["Contact", userData.contact],
                                    ].map(([label, value]) => (
                                        <Typography key={label} variant="body2" sx={{ color: "#c9d1d9", mb: 1 }}>
                                            <strong>{label}:</strong> {value}
                                        </Typography>
                                    ))}
                                </Card>
                            </motion.div>

                            {/* Pricing & Coupon */}
                            <motion.div whileHover={{ scale: 1.02 }}>
                                <Card sx={{ bgcolor: "#0d1117", p: 3, borderRadius: 3 }}>
                                    <Typography variant="h6" sx={{ color: "#ffffff", mb: 2, letterSpacing: 2 }}>
                                        Pricing & Coupon
                                    </Typography>
                                    <Divider sx={{ bgcolor: "#30363d", mb: 2 }} />
                                    {[
                                        ["Base Price", `₹${price}`],
                                        ["GST (18%)", `₹${gstAmount}`],
                                        // ["Gateway Fee (2%)", `₹${gatewayAmount}`],
                                        [
                                            "Total Payment",
                                            `₹${parseFloat(baseTotalPrice)}`,
                                        ],
                                    ].map(([label, value]) => (
                                        <Typography key={label} variant="body2" sx={{ color: "#c9d1d9", mb: 1 }}>
                                            <strong>{label}:</strong> {value}
                                        </Typography>
                                    ))}

                                    {/* Coupon Input or Applied */}
                                    <Box mt={2}>
                                        {couponApplied ? (
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Typography sx={{ color: "success.main", fontWeight: 600 }}>
                                                    {couponDiscountPercent}% OFF
                                                </Typography>
                                                <Button variant="outlined" color="error" size="small" onClick={handleRemoveCoupon}>
                                                    Remove
                                                </Button>
                                            </Stack>
                                        ) : (
                                            <Grid container spacing={1}>
                                                <Grid item xs={8}>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        label="Enter Coupon Code"
                                                        value={couponCode}
                                                        onChange={(e) => setCouponCode(e.target.value)}
                                                        sx={{
                                                            backgroundColor: "white",
                                                            borderRadius: 1,
                                                            input: { color: "black" },
                                                            label: { color: "gray" },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        onClick={handleApplyCoupon}
                                                        sx={{
                                                            height: "100%",
                                                            backgroundColor: "#32CD32",
                                                            "&:hover": {
                                                                backgroundColor: "#28a745",
                                                                transform: "scale(1.05)",
                                                            },
                                                            fontWeight: "bold",
                                                            letterSpacing: 2,
                                                        }}
                                                    >
                                                        Apply
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                </Card>
                            </motion.div>

                            <Card sx={{ bgcolor: "#0d1117", p: 3, borderRadius: 3 }}>
  <Typography variant="h6" sx={{ color: "#fff", mb: 2 }}>
    Payment Method
  </Typography>

  <Divider sx={{ bgcolor: "#30363d", mb: 2 }} />

  <Grid container spacing={2}>
    
    {/* Razorpay */}
    <Grid item xs={6}>
      <Box
        onClick={() => setPaymentMethod("razorpay")}
        sx={{
          p: 2,
          borderRadius: 2,
          cursor: "pointer",
          border:
            paymentMethod === "razorpay"
              ? "2px solid #3b82f6"
              : "1px solid #30363d",
          textAlign: "center",
        }}
      >
        <Typography sx={{ color: "#fff" }}>Razorpay</Typography>
      </Box>
    </Grid>

    {/* PhonePe */}
    <Grid item xs={6}>
      <Box
        onClick={() => setPaymentMethod("phonepe")}
        sx={{
          p: 2,
          borderRadius: 2,
          cursor: "pointer",
          border:
            paymentMethod === "phonepe"
              ? "2px solid #9333ea"
              : "1px solid #30363d",
          textAlign: "center",
        }}
      >
        <Typography sx={{ color: "#fff" }}>PhonePe</Typography>
      </Box>
    </Grid>
  </Grid>

  {/* PhonePe UI */}
  
</Card>

                            {/* Confirm & Pay */}
                            <motion.div whileHover={{ scale: 1.02 }}>
                                <Card sx={{ bgcolor: "#0d1117", p: 3, borderRadius: 3 }}>
                                    <Typography variant="h6" sx={{ color: "#ffffff", mb: 2, letterSpacing: 2 }}>
                                        Confirm & Pay
                                    </Typography>

                                    <Divider sx={{ bgcolor: "#30363d", mb: 2 }} />

                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 'bold',
                                            color: couponApplied ? 'success.main' : 'warning.main',
                                            mt: 1,
                                        }}
                                    >
                                        Final Price: ₹{(couponApplied ? parseFloat(totalDiscountedPrice) : totalPrice).toFixed(2)}
                                    </Typography>

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isChecked}
                                                onChange={handleCheckboxChange}
                                                sx={{
                                                    color: "primary.light",
                                                    "&.Mui-checked": { color: "primary.main" },
                                                }}
                                            />
                                        }
                                        label="I confirm all details are correct."
                                        sx={{ color: "#c9d1d9", mt: 1 }}
                                    />
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        onClick={() => {
  if (paymentMethod === "razorpay") {
    handlePayment();
  } else {
    handlePhonePePayment();
  }
}}
                                        disabled={!isChecked}
                                        sx={{
                                            mt: 3,
                                            bgcolor: "primary.main",
                                            "&:hover": {
                                                bgcolor: "primary.main", // Same as normal
                                                transform: "scale(1.02)",
                                            },
                                            letterSpacing: 2,
                                            py: 1.5,
                                        }}
                                    >
                                        Pay Now
                                    </Button>
                                </Card>
                            </motion.div>
                        </Stack>
                    </Grid>
                </Grid>

                {loading && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 2000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backdropFilter: 'blur(3px)',
                        }}
                    >
                        <Box sx={{ textAlign: 'center' }}>
                            <CircularProgress
                                size={60}
                                thickness={6}
                                sx={{
                                    color: 'transparent',
                                    '& .MuiCircularProgress-circle': {
                                        stroke: 'url(#better-gradient)',
                                    },
                                }}
                            />

                            <svg width="0" height="0">
                                <defs>
                                    <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                                        <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                                        <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                                    </linearGradient>
                                </defs>
                            </svg>

                            <Typography
                                variant="h6"
                                sx={{
                                    mt: 2,
                                    color: '#fff',
                                    textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                                }}
                            >
                                Loading Details... ({loadingSeconds} sec)
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Container>
            <IconButton
                onClick={scrollToTop}
                sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black', letterSpacing: 2 }}>
                <ArrowUpwardIcon />
            </IconButton>
            <Footer2 />
        </div>

    );
};

export default NewSubscriptionPayments;
